import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardComponent } from './dashboard.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { RecentClientsComponent } from './recentclients/recentclients.component';
import { BirthdaysComponent } from './birthdays/birthdays.component';
import { BirthdaysAllComponent } from './birthdays/birthdays-all/birthdays-all.component';

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [],
    declarations: [
        DashboardComponent,
        NotificationsComponent,
        RecentClientsComponent,
        BirthdaysComponent,
        BirthdaysAllComponent,
    ]
})
export class DashboardModule { }
